import * as types from './mutation-types'

const state = {
  loadingCalendars: false,
  calendars: {
    data: [],
  },
  calendar: {
    sources: {
      data: [],
    },
    attributes: {
      title: '',
      subscribe_url: '',
      description: '',
    },
    calendarType: {
      id: '',
      attributes: {
        slug: '',
        title: '',
      },
    },
    groups: {
      data: [],
    },
  },
  calendarTypes: {
    data: [],
  },
  calendarType: {
    id: '',
    attributes: {
      slug: '',
      title: '',
    },
  },
  source: {
    uuid: '',
    attributes: {
      title: '',
      background_color: '',
      text_color: '',
      external_id: '',
    },
  },
  deleteCalendarEventModal: {
    open: false,
    calendar: null,
  },
  createCalendarSourceModal: {
    open: false,
    calendarUuid: null,
  },
  deleteCalendarSourceModal: {
    open: false,
    source: null,
  },
  editCalendarSourceModal: {
    open: false,
    source: null,
  },
  setVisibilityModal: {
    open: false,
    calendar: null,
  },
  eventSources: [],
  fullCalendarConfig: {
    'editable': false,
    'defaultView': 'month',
  },
}

const mutations = {
  [types.CALENDAR_LOADING_CALENDARS](state, isLoading) {
    state.loadingCalendars = isLoading
  },
  [types.CALENDAR_SET_CALENDAR](state, Calendar) {
    state.calendar = Calendar
  },
  [types.CALENDAR_SET_CALENDARS](state, Calendars) {
    state.calendars = Calendars
  },
  [types.CALENDAR_OPEN_DELETE_CALENDAR_EVENT_MODAL](state, Calendar) {
    state.deleteCalendarEventModal.open = true
    state.deleteCalendarEventModal.calendar = Calendar
  },
  [types.CALENDAR_CLOSE_DELETE_CALENDAR_EVENT_MODAL](state) {
    state.deleteCalendarEventModal.open = false
    state.deleteCalendarEventModal.calendar = null
  },
  [types.CALENDAR_OPEN_CREATE_CALENDAR_SOURCE_MODAL](state, CalendarUuid) {
    state.createCalendarSourceModal.open = true
    state.createCalendarSourceModal.calendarUuid = CalendarUuid
  },
  [types.CALENDAR_CLOSE_CREATE_CALENDAR_SOURCE_MODAL](state) {
    state.createCalendarSourceModal.open = false
    state.createCalendarSourceModal.calendarUuid = null
  },
  [types.CALENDAR_OPEN_EDIT_CALENDAR_SOURCE_MODAL](state, Source) {
    state.editCalendarSourceModal.open = true
    state.editCalendarSourceModal.source = Source
  },
  [types.CALENDAR_CLOSE_EDIT_CALENDAR_SOURCE_MODAL](state) {
    state.editCalendarSourceModal.open = false
    state.editCalendarSourceModal.source = null
  },
  [types.CALENDAR_OPEN_DELETE_CALENDAR_SOURCE_MODAL](state, Source) {
    state.deleteCalendarSourceModal.open = true
    state.deleteCalendarSourceModal.source = Source
  },
  [types.CALENDAR_CLOSE_DELETE_CALENDAR_SOURCE_MODAL](state) {
    state.deleteCalendarSourceModal.open = false
    state.deleteCalendarSourceModal.calendarUuid = null
  },
  [types.CALENDAR_OPEN_SET_VISIBILITY_MODAL](state, Calendar) {
    state.setVisibilityModal.open = true
    state.setVisibilityModal.calendar = Calendar
  },
  [types.CALENDAR_CLOSE_SET_VISIBILITY_MODAL](state) {
    state.setVisibilityModal.open = false
    state.setVisibilityModal.calendar = null
  },
  [types.CALENDAR_SET_EVENT_SOURCES](state, Sources) {
    state.eventSources = Sources
  },
  [types.CALENDAR_SET_CALENDAR_TYPES](state, Types) {
    state.calendarTypes = Types
  },
}

export default {
  state,
  mutations,
}